import React from 'react';
import { browserHistory, Link } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { needsAuth } from './utils/authHoc';
import { switchCourse } from '../actions/courses';

import Tab from 'react-bootstrap/lib/Tab';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { Translate } from 'react-redux-i18n';

import TranslatedText from '../i18n/TranslatedText';

import './SelectLesson.scss';
import './select-lesson-rts.scss';

const GUI_SANDBOX_PLATFORMS = ['snap', 'code'];

const getPlatformLogo = platform => {
  if (platform === 'code') {
    return require('../assets/images/python.png');
  }
  if (platform === 'tinkercad') {
    return require('../assets/images/tinkercad.png');
  }
  return require(`../assets/images/${platform}.png`);
};

const getPlatformLabel = platform => {
  if (platform === 'code') {
    return 'python';
  }
  if (platform === 'tinkercad') {
    return 'tinkercad';
  }
  return platform;
};

class SelectLesson extends React.PureComponent {
  constructor(...props) {
    super(...props);

    this.selectSection = this.selectSection.bind(this);
  }

  componentDidMount() {
    const { dispatch, courseId } = this.props;
    dispatch(switchCourse(courseId));
  }

  componentWillReceiveProps(newProps) {
    const { dispatch, courseId, location } = newProps;
    if (
      courseId !== this.props.courseId ||
      location.pathname !== this.props.location.pathname
    ) {
      dispatch(switchCourse(courseId));
    }
  }

  selectSection(s) {
    const { platform, courseId } = this.props;
    browserHistory.push(`/i/${platform}/${courseId}/${s}`);
  }

  renderCourseCard(platform) {
    return (
      <div className="select-lesson-course-card">
        <img
          className="select-lesson-course-card__logo"
          src={getPlatformLogo(platform)}
          alt={getPlatformLabel(platform)}
        />
      </div>
    );
  }

  render() {
    const { selectedCourse, platform, courseId, section } = this.props;
    const isCourseLoaded = selectedCourse && selectedCourse._id === courseId;
    const sections = isCourseLoaded
      ? (selectedCourse.sections || []).filter(s => !!s)
      : [];
    const activeSectionIndex = sections[section] ? section : 0;
    const activeSection = sections[activeSectionIndex];

    return (
      <Tab.Container
        id="tabs-select-lesson"
        className="select-lesson-page select-lesson-page--rts course-navigation select-lesson-layout"
        activeKey={activeSectionIndex}
        onSelect={this.selectSection}
      >
        <div>
        <aside className="select-section select-lesson-sidebar">
          <div className="select-lesson-sidebar__top">
            <Link to={`/i/${platform}`} className="select-lesson-back">
              <i className="fa fa-angle-left select-lesson-back__icon" aria-hidden="true" />
              <span className="select-lesson-back__text">
                <Translate value="lessons.back" />
              </span>
            </Link>
          </div>

          {isCourseLoaded && this.renderCourseCard(platform)}

          {sections.length > 0 && (
            <p className="select-lesson-sections-title">
              <Translate value="lessons.sections" />
            </p>
          )}

          <Nav
            bsStyle="pills"
            stacked
            className="select-lesson-sections"
          >
            {sections.map((s, i) => (
              <NavItem
                key={`section_${s._id}`}
                eventKey={i}
                className="tab-control"
              >
                <span className="section-num">{i + 1}.</span>
                <span className="section-title">
                  <TranslatedText text={s.title} />
                </span>
                {s.complete ? <span className="section-complete" /> : null}
              </NavItem>
            ))}
          </Nav>

          {isCourseLoaded &&
            selectedCourse.homeworks &&
            selectedCourse.homeworks.length > 0 && (
              <div className="select-lesson-extra">
                <p className="select-lesson-extra__title">
                  <Translate value="lessons.homeworks" />
                </p>
                {selectedCourse.homeworks
                  .filter(homework => !!homework.name)
                  .map((homework, i) => (
                    <Link
                      key={`homework_${homework._id}`}
                      to={`/i/${selectedCourse.type}/${homework._id}`}
                      className="select-lesson-extra__link"
                    >
                      <b>{i + 1}. </b>
                      <TranslatedText text={homework.name} />
                    </Link>
                  ))}
              </div>
            )}

          {isCourseLoaded &&
            GUI_SANDBOX_PLATFORMS.includes(selectedCourse.type) && (
            <div className="select-lesson-extra">
              <Link
                to={`/i/gui/${selectedCourse.type}`}
                className="select-lesson-extra__link"
              >
                <Translate value="lessons.sandbox" />
              </Link>
            </div>
          )}
        </aside>

        {isCourseLoaded && (
          <div
            style={selectedCourse.shortcut ? {} : { cursor: 'progress' }}
            className="select-theme select-lesson-main"
          >
            <div className="select-lesson-header">
              <span className="platform">{getPlatformLabel(platform)}</span>
              <h1 className="course-title">
                <TranslatedText text={selectedCourse.name} />
              </h1>
              <p className="description">
                <TranslatedText text={selectedCourse.description} />
              </p>
            </div>

            {selectedCourse.type !== 'plain' ? (
              <div className="progress-section block-element">
                <div className="content">
                  <button
                    className={`btn btn-green btn-medium ${
                      selectedCourse.shortcut ? '' : 'disabled'
                    }`}
                    disabled={!selectedCourse.shortcut}
                    onClick={() =>
                      browserHistory.push(
                        `/i/gui/${platform}/${selectedCourse.shortcut.lesson}/${
                          selectedCourse.shortcut.task
                        }`
                      )
                    }
                  >
                    {selectedCourse.completition > 0 ? (
                      <Translate value="lessons.continue" />
                    ) : (
                      <Translate value="lessons.start" />
                    )}
                  </button>

                  <div className="progress-wrap">
                    <p className="progress-label">
                      <Translate value="lessons.progress" />
                    </p>
                    <div className="progress-row">
                      <div className="progress-container">
                        <ProgressBar now={selectedCourse.completition} />
                      </div>
                      <div className="progress-value">
                        {selectedCourse.completition}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="theme-block block-element">
              <div className="theme-header">
                <span className="number">{activeSectionIndex + 1}</span>
                {activeSection && (
                  <span className="theme-header__title">
                    <TranslatedText text={activeSection.title} />
                  </span>
                )}
              </div>

              <Tab.Content animation className="content theme-section">
                {activeSection && (
                  <div className="section-description">
                    <TranslatedText text={activeSection.description} />
                  </div>
                )}

                {sections.map((s, i) => (
                  <Tab.Pane eventKey={i} key={`section_pane_${s._id}`}>
                    {(s.themes || [])
                      .filter(t => !!t)
                      .map(t => (
                        <div className="theme-element" key={`theme_${t._id}`}>
                          <div className="col-xs-4">
                            <p className="theme-title">
                              <TranslatedText text={t.title} />
                            </p>
                            <p className="theme-description">
                              <TranslatedText text={t.description} />
                            </p>
                          </div>

                          <div className="col-xs-8 lesson-section">
                            {(t.lessons || [])
                              .filter(l => !!l)
                              .map(l => (
                                <button
                                  type="button"
                                  onClick={() =>
                                    browserHistory.push(
                                      `/i/gui/${platform}/${l._id}/0`
                                    )
                                  }
                  className={`btn lesson ${
                                    !l.complete ? 'complete' : ''
                                  }`}
                                  key={`lesson_${l._id}`}
                                >
                                  <TranslatedText text={l.title} />
                                </button>
                              ))}
                          </div>
                        </div>
                      ))}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </div>
          </div>
        )}
        </div>
      </Tab.Container>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { selectedCourse } = state.courses;
  const {
    params: { course: courseId, platform, section },
  } = ownProps;

  const s = parseInt(section, 10);
  return {
    selectedCourse,
    courseId,
    platform,
    section: s || 0,
  };
};

export default compose(needsAuth, connect(mapStateToProps))(SelectLesson);
